import { useEffect } from "react";
import { NativeSelect } from "./common";

export function ProjectSelect({ projects, value, onChange, stages, testid = "project-select" }) {
  const list = stages ? projects.filter((p) => stages.includes(p.stage)) : projects;
  useEffect(() => {
    if (list.length && !list.find((p) => p.id === value)) onChange(list[0].id);
  }, [list, value, onChange]);
  return (
    <NativeSelect
      testid={testid}
      value={value || ""}
      onChange={onChange}
      className="min-w-[220px]"
      options={list.map((p) => ({ value: p.id, label: `${p.name} · ${p.stage}` }))}
    />
  );
}
